import React from "react";
import Button from "./Button";
import Wrap from "./Wrap";
import Input from "./Input";

export default ({ update, handleTitleChange, title }) => {
  return (
    <Wrap justifyContent="flex-end" alginItems="center" margin="0 0 15px">
      <Wrap margin="auto 10px auto auto" width="100%">
        <Input
          name="title"
          placeholder="コメント（編集の概要や修正内容など）"
          onChange={handleTitleChange}
          value={title}
        />
      </Wrap>
      <Button onClick={() => update(false)} style={{ marginLeft: 10 }}>
        保存
      </Button>
      <Button onClick={() => update(true)} style={{ marginLeft: 10 }}>
        保存して公開
      </Button>
    </Wrap>
  );
};
